// assets
import { IconDashboard } from '@tabler/icons';

// constant
const icons = { IconDashboard };
import SecurityService from "services/SecurityService";
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

let dashboard = {
    id: 'dashboard',
    title: '',
    type: 'group',
    children: []
};

if (SecurityService.userIsGrantedTo('dashboard')) {
    dashboard.children.push({
        id: 'default',
        title: 'Home',
        type: 'item',
        url: '/',
        icon: icons.IconDashboard,
        breadcrumbs: false
    });
}

export default dashboard;
